@if (accessChecked && calendarVisible) {
<div class="calendar-card">
  <div class="calendar-card-header">
    <mat-icon>calendar_month</mat-icon>
    <h3>{{ getInput("tableTitle") || "Gruppekalender" }}</h3>
  </div>
  @if (getInput('tableDescription')) {
  <p class="calendar-card-description">{{ getInput("tableDescription") }}</p>
  }
  <app-group-calendar-grid
    [monthData]="monthData"
    [locationOptions]="locationOptions"
    [settings]="settings"
    [groups]="groups"
    [showGroupColumn]="showGroupColumn"
    [isLoading]="isLoading"
    [monthLabel]="monthLabel"
    [viewYear]="viewYear"
    [templateStats]="templateStats"
    [statsLocationColumns]="statsLocationColumns"
    [showSettingsButton]="false"
    [canEditCell]="canEditCell"
    [readOnlyGroupColumn]="true"
    (prevMonthClicked)="prevMonth()"
    (nextMonthClicked)="nextMonth()"
    (cellClicked)="onCellClickFromGrid($event)"
    (eventDropped)="onEventDroppedFromGrid($event)"
    (chipClicked)="onChipClickFromGrid($event)"
  >
  </app-group-calendar-grid>
</div>
}
